import React from "react";
import { styled } from "goober";

import LoadingSpinnerIcon from "../Icons/loading-spinner.svg";

const SpinnerContainer = styled("span")<{ $position?: string }>`
  --spinner-size: 7rem;

  position: ${({ $position }) => $position ?? "absolute"};

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;
  min-height: 400px;

  color: var(--spinner-color, inherit);

  svg {
    width: var(--spinner-size);
    height: var(--spinner-size);
  }
`;

const FlexibleSpinnerContainer = styled(SpinnerContainer)`
  --spinner-size: 100%;

  min-height: 0;
  position: relative;
`;

const ButtonSpinnerContainer = styled(FlexibleSpinnerContainer)`
  --spinner-size: 1em;
`;

export function LoadingSpinner(
  props: React.HTMLAttributes<HTMLSpanElement> & { $position?: string },
) {
  return (
    <SpinnerContainer
      className="loading-spinner"
      role="alert"
      aria-busy="true"
      {...props}
    >
      <LoadingSpinnerIcon />
    </SpinnerContainer>
  );
}

// TODO: Get a spinner icon that is easier to see at button size
export function ButtonLoadingSpinner(
  props: React.HTMLAttributes<HTMLSpanElement> & { $position?: string },
) {
  return (
    <ButtonSpinnerContainer
      className="loading-spinner"
      role="alert"
      aria-busy="true"
      {...props}
    >
      <LoadingSpinnerIcon />
    </ButtonSpinnerContainer>
  );
}

export function FlexibleLoadingSpinner({
  alert,
  ...rest
}: React.HTMLAttributes<HTMLSpanElement> & {
  $position?: string;
  alert?: boolean;
}) {
  return (
    <FlexibleSpinnerContainer
      className="loading-spinner"
      {...(alert !== false && { role: "alert", "aria-busy": "true" })}
      {...rest}
    >
      <LoadingSpinnerIcon />
    </FlexibleSpinnerContainer>
  );
}
